import "./ForestSupervisor.module.css";
import Header from "@/reusable_sections/Header";
import ResumenDelCurso from "./sections/ResumenDelCurso";
import DetallesDelCurso from "./sections/DetallesDelCurso";
import InvitacionAInscribirse from "./sections/InvitacionAInscribirse";
import Footer from "@/reusable_sections/Footer";
export default function ForestSupervisorPage() {
  return <div>
      <Header />
      <ResumenDelCurso />
      <DetallesDelCurso />
      <InvitacionAInscribirse />
      <Footer />
    </div>;
}